import React from 'react';

export default function TileThumbnail({ thumb }) {
    return (
        <div className="tile-image-wrapper">
            <div className="tile-image">
                <img src={thumb} alt="" />
            </div>
        </div>
    );
}

TileThumbnail.propTypes = { thumb: React.PropTypes.string.isRequired };



// WEBPACK FOOTER //
// ./src/components/tiles/common/TileThumbnail.jsx